
define('text!templates/appMain/privilegedMain/qm/policies/editors/evaluationFormSelector.html',[],function () { return '<input type="hidden" class="evaluationSelector" data-bind="combobox: {\n    search: getPublishedEvaluationForms,\n    value: evaluationForm,\n    placeholder: placeholderText\n}">';});

